import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const orderDetailImporterSelectors = importerSelectors(
  'orderDetail.importer',
)

export default orderDetailImporterSelectors
